import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {forwardRef} from "react";

interface IProps {
    title: string
    signing_date: string
    closing_date: string
}

const ProjectHeader = forwardRef<any, IProps>((props: IProps, ref) => {

    return (
        <Box ref={ref} sx={{display: 'flex', flexDirection: 'row'}}>
            <Box sx={{display: 'flex', flex: 5.7, flexDirection: 'Column'}}>
                <Box>
                    <Box sx={{display: 'flex', background: '#c81e1e', alignItems: 'center', minHeight: "50px"}}>
                        <Box sx={{display: 'flex', flex: 3.5, flexDirection: 'row', paddingLeft: 2}}>
                            <Typography sx={{color: 'white', maxWidth:"600px", fontSize:"20px", fontWeight:"600"}}
                                        // variant="h6"
                                        component="span"
                                        // noWrap={true}
                            >
                                {props.title || ''}
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flex: 2.5,
                            flexDirection: 'row',
                            backgroundColor: '#e5e5e6',
                            paddingLeft: 1,
                            borderRadius: 1,
                            justifyContent: 'space-evenly',
                            marginRight: 3
                        }}>
                            <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                <Typography sx={{fontWeight: 'bold'}}
                                            variant="body1"
                                            component="div"
                                >
                                    Signing Date:
                                </Typography>
                                <Typography sx={{paddingLeft: 2}}
                                            variant="body1"
                                            component="div"
                                >
                                    {props.signing_date}
                                </Typography>
                            </Box>
                            <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                <Typography sx={{fontWeight: 'bold'}}
                                            variant="body1"
                                            component="div"
                                >
                                    Closing Date:
                                </Typography>
                                <Typography sx={{paddingLeft: 2}}
                                            variant="body1"
                                            component="div"
                                >
                                    {props.closing_date}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
});
export default ProjectHeader
